// Friendly copy for room close codes. `terminal: true` means this state
// is final — host kicked, session full, etc. — so the UI should not
// offer a "retry" CTA for the same room. `displayMessage` is the
// primary user-facing string; titles are kept lightweight (the body
// reads as a sentence on its own).
export const RoomErrorCodes = {
    4001: {
        displayMessage: "The room was closed because it was inactive for too long."
    },
    4002: {
        displayMessage: "Disconnected — the host left before reconnecting."
    },
    4003: {
        displayMessage: "Disconnected because the host joined the wrong game."
    },
    4004: {
        displayMessage: "Disconnected — no host was connected when this room opened."
    },
    4005: {
        displayMessage: "Disconnected — no host was connected when this room closed."
    },
    4006: {
        displayMessage: "This room is full.",
        terminal: true
    },
    4008: {
        displayMessage: "The host stopped the Connect session.",
        terminal: true
    },
    4009: {
        displayMessage: "The host removed you from this Connect session.",
        terminal: true
    },
    4011: {
        displayMessage: "Connect is full — the host already has 8 connected guests.",
        terminal: true
    },
    4012: {
        displayMessage: "You were removed from this Connect session — ask the host to invite you back.",
        terminal: true
    },
    4050: {
        displayMessage: "You were removed from this session.",
        terminal: true
    },
    4100: {
        displayMessage: "That PIN doesn't match this room."
    },
    4200: {
        displayMessage: "The session has ended."
    },
    default: {
        displayMessage: "Lobby Closed"
    }
}

/**
 * Returns true if the given close code represents a terminal state —
 * one where retrying with the same room/code is pointless because the
 * server has explicitly cut this client. Used by leave-state UIs to
 * decide between "Try again" and "Back to Connect" CTAs.
 */
export const isTerminalRoomError = (code) => !!RoomErrorCodes[code]?.terminal;